import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./NoMatch.css";
export const NoMatch = () => {

    return (
      <Container className="error">
					<Row>
						<Col className="text-center">
							<Card bg="primary" className="errorContainer col-md-3" body>
								<h2 className="mb-3">
                Nothing to see here!
								</h2>
								<Link to="/home">Go to the home page</Link>
							</Card>
						</Col>
					</Row>
				</Container>
    );
  }